import { render, staticRenderFns } from "./BalanceBox.vue?vue&type=template&id=11c7bf29&scoped=true"
import script from "./BalanceBox.vue?vue&type=script&lang=js"
export * from "./BalanceBox.vue?vue&type=script&lang=js"
import style0 from "./BalanceBox.vue?vue&type=style&index=0&id=11c7bf29&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_prettier@3.1.1_vue-template-compiler@2.7.16_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c7bf29",
  null
  
)

export default component.exports